module.exports = "table {\r\n  tr {\r\n    th {\r\n      vertical-align: middle;\r\n    }\r\n    td {\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/table/table.component.css
// module id = ./src/app/shared/components/table/table.component.css
// module chunks = main